import { SVGProps } from 'react';

interface AssistantIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const AssistantIcon = ({ width = 11, height = 10, color = '#FFFFFF', ...props }: AssistantIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 11 10"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.23493 0.935391C5.94974 -0.316531 4.16187 -0.310538 3.88719 0.945899L3.87668 0.995443L3.85415 1.09301C3.69975 1.78281 3.3442 2.41131 2.83249 2.89897C2.32078 3.38663 1.67591 3.71154 0.979486 3.83259C-0.326495 4.06076 -0.326495 5.93717 0.979486 6.16383C1.67931 6.28542 2.327 6.61285 2.83984 7.10431C3.35268 7.59576 3.70739 8.22893 3.85866 8.92294L3.88719 9.05351C4.16187 10.31 5.94974 10.3175 6.23493 9.06402L6.26949 8.91092C6.42732 8.21991 6.78581 7.59093 7.29992 7.10299C7.81404 6.61504 8.46087 6.28988 9.15918 6.16834C10.4696 5.94017 10.4696 4.06076 9.15918 3.83259C8.44442 3.70855 7.7839 3.37119 7.26441 2.86483C6.74492 2.35847 6.39076 1.7068 6.24848 0.995443L6.23493 0.935391Z"
        fill={color}
      />
    </svg>
  );
};

export default AssistantIcon;
